import { Navigate, useLocation } from "react-router-dom";

import { BlobShipMark } from "../components/BlobShipMark";
import { login, useSession } from "../lib/auth";

/**
 * BlobShip has no login of its own — it's an OpsBelt relying party. This screen
 * just sends the user to OpsBelt to sign in / sign up; they come straight back.
 */
export function LoginPage() {
  const { data: session, isPending } = useSession();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/";

  if (!isPending && session) return <Navigate to={from} replace />;

  return (
    <div className="flex min-h-full items-center justify-center bg-surface-50 px-4 py-12">
      <div className="w-full max-w-sm text-center">
        <div className="mb-6 flex items-center justify-center gap-2.5">
          <BlobShipMark size={32} className="text-accent" />
          <div className="font-display text-xl font-bold tracking-tight text-ink">
            Blob<span className="text-accent">Ship</span>
          </div>
        </div>

        <div className="card p-6">
          <h1 className="font-display text-lg font-semibold text-ink">
            Sign in to BlobShip
          </h1>
          <p className="mt-1 text-sm text-ink-muted">
            BlobShip runs on your OpsBelt account — one login for every tool on the belt.
          </p>
          <button
            type="button"
            className="btn-primary mt-5 w-full"
            onClick={() => login()}
          >
            Continue with OpsBelt
          </button>
          <p className="mt-4 text-xs text-ink-subtle">
            New here? You'll create your OpsBelt account in the next step.
          </p>
        </div>
      </div>
    </div>
  );
}
